<template>
  <img v-if="isIconImage(itemIcon)" class="menu-icon-manager" :src="itemIcon" :alt="findAttributeOnSiteInfo('site_name')[0]">
  <m-icon v-else class="base-menu-item-icon ml-1" :icon="itemIcon"/>
</template>

<script>
import mIcon from "../Icons/Icon.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "MenuIconManager",
  components: {mIcon},
  props: {
    itemIcon: {
      default: null
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    isIconImage() {
      let icon_class = this.itemIcon
      if (icon_class != null && icon_class.indexOf('storage/') > -1) return true
      return false
    }
  }
}
</script>


<style scoped>
.menu-icon-manager {
  height: 30px;
  width: 30px;
  object-fit: cover;
  margin: 0 6px;
}
</style>